import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import theme from "./theme.ts";
import {ThemeProvider} from '@mui/material/styles';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App.tsx';
import ArtStory from './ArtStory/ArtStory.tsx';
import Gallery from './Gallery/Gallery.tsx';
import Contact from './Contact/Contact.tsx';
import Exhibitions from './Exhibitions/Exhibitions.tsx';
import GalleryViewer from './Gallery/GalleryViewer.tsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/art-story" element={<ArtStory />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/gallery/:image_index" exact element={<GalleryViewer />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/exhibitions" element={<Exhibitions />} />
        </Routes>
      </ThemeProvider>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
